import { defineMessages } from 'react-intl';

export const cookieBannerMessages = defineMessages({
  consentTitle: {
    id: 'csj.cookie.consentTitle',
    defaultMessage: 'Informació sobre cookies',
  },
  consentDescription: {
    id: 'csj.cookie.consentDescription',
    defaultMessage:
      "El lloc web de la Clínica Sant Josep de Manresa utilitza cookies pròpies i de tercers amb la finalitat de gestionar les vostres preferències, amb finalitats estadístiques o de màrqueting. Si voleu configurar les cookies, premeu l'opció «Permetre la selecció». Seleccionant «Rebutjar totes les cookies» estareu acceptant només les cookies estrictament necessàries. Per a obtenir més informació sobre les cookies, visiteu la {cookiesLink} de la nostra pàgina web.",
  },
  cookiesPolicyLink: {
    id: 'csj.cookie.cookiesPolicyLink',
    defaultMessage: 'Informació sobre cookies',
  },
  acceptAll: {
    id: 'csj.cookie.acceptAll',
    defaultMessage: 'Acceptar totes les cookies',
  },
  rejectAll: {
    id: 'csj.cookie.rejectAll',
    defaultMessage: 'Rebutjar totes les cookies',
  },
  configure: {
    id: 'csj.cookie.configure',
    defaultMessage: 'Permetre la selecció',
  },
  preferencesTitle: {
    id: 'csj.cookie.preferencesTitle',
    defaultMessage: 'Configuració de les cookies',
  },
  preferencesIntro: {
    id: 'csj.cookie.preferencesIntro',
    defaultMessage: 'Selecciona les cookies que vols acceptar:',
  },
  savePreferences: {
    id: 'csj.cookie.savePreferences',
    defaultMessage: 'Guardar configuració',
  },
  back: {
    id: 'csj.cookie.back',
    defaultMessage: 'Enrere',
  },
  closePreferences: {
    id: 'csj.cookie.closePreferences',
    defaultMessage: 'Tancar',
  },
  necessaryTitle: {
    id: 'csj.cookie.necessaryTitle',
    defaultMessage: 'Cookies estrictament necessàries',
  },
  necessaryBadge: {
    id: 'csj.cookie.necessaryBadge',
    defaultMessage: 'Sempre activat',
  },
  necessaryDescription: {
    id: 'csj.cookie.necessaryDescription',
    defaultMessage:
      "Cookies tècniques: Són les que permeten que l'usuari navegui per una pàgina web, plataforma o aplicació i utilitzi les diverses opcions o serveis que hi ha a la pàgina, com ara controlar el trànsit i la comunicació de dades, identificar la sessió, accedir a parts d'accés restringit, recordar els elements que integren una comanda, fer el procés de compra d'una comanda, fer la sol·licitud d'inscripció o participació en un esdeveniment, utilitzar elements de seguretat durant la navegació, emmagatzemar continguts per difondre vídeos o arxius de so, o compartir continguts a través de les xarxes socials.\n\nCookies de personalització: Són les que permeten que l'usuari accedeixi al servei amb algunes característiques de caràcter general predefinides sobre la base d'una sèrie de criteris en el terminal de l'usuari, com ara l'idioma, el tipus de navegador a través del qual accedeix al servei, la configuració regional des d'on accedeix al servei, etc.",
  },
  trackingTitle: {
    id: 'csj.cookie.trackingTitle',
    defaultMessage: "Cookies d'anàlisi",
  },
  trackingDescription: {
    id: 'csj.cookie.trackingDescription',
    defaultMessage:
      "Són les que permeten que qui n'és responsable faci el seguiment i l'anàlisi del comportament dels usuaris per mesurar l'activitat dels llocs web, aplicacions o plataformes i per elaborar perfils de navegació dels usuaris d'aquests llocs, aplicacions i plataformes, amb la finalitat d'introduir millores a partir de l'anàlisi de les dades d'ús que fan els usuaris del servei.",
  },
  marketingTitle: {
    id: 'csj.cookie.marketingTitle',
    defaultMessage: 'Cookies publicitàries',
  },
  marketingDescription: {
    id: 'csj.cookie.marketingDescription',
    defaultMessage:
      "Són aquelles que permeten la gestió, de la forma més eficaç possible, dels espais publicitaris que, en el seu cas, l'editor hagi inclòs en una pàgina web, aplicació o plataforma des de la que presta el servei sol·licitat, en base a criteris com el contingut editat o la freqüència en la que es mostren els anuncis.",
  },
  behavioralTitle: {
    id: 'csj.cookie.behavioralTitle',
    defaultMessage: 'Cookies de publicitat comportamental',
  },
  behavioralDescription: {
    id: 'csj.cookie.behavioralDescription',
    defaultMessage:
      "Són aquelles que permeten la gestió, de la forma més eficaç possible dels espais publicitaris que, en el seu cas, l'editor hagi inclòs en una pàgina web, aplicació o plataforma des de la que presta el servei sol·licitat. Aquestes cookies emmagatzemen informació del comportament dels usuaris obtinguda a través de l'observació continuada dels seus hàbits de navegació, el que permet desenvolupar un perfil específic per mostrar publicitat en funció del mateix.",
  },
  youtubeLabel: {
    id: 'csj.cookie.youtubeLabel',
    defaultMessage: 'Youtube',
  },
});

export default cookieBannerMessages;
